type TotalSalaryIncome = {
  mainJobIncome: string;
  sideJobIncome: string;
  formerJobsPaymentAmountSum: string;
};

const calcSalaryEarning = (x: number): number => {
  if (x < 551000) {
    return 0;
  } else if (x < 1619000) {
    return x - 550000;
  } else if (x < 1620000) {
    return 1069000;
  } else if (x < 1622000) {
    return 1070000;
  } else if (x < 1624000) {
    return 1072000;
  } else if (x < 1628000) {
    return 1074000;
  } else if (x < 6600000) {
    const y = Math.floor(x / 4000) * 1000;
    return Math.floor(Math.max(24 * y + 1000000, 28 * y - 800000, 32 * y - 4400000) / 10);
  } else {
    return Math.floor(Math.max(9 * x - 11000000, 10 * x - 19500000) / 10);
  }
};

export const parseNumber = (num: number | string | null | undefined): number => +(num ? String(num).replace(/,/g, '') : 0);

export const salaryEarnings = (value: number): number => {
  return calcSalaryEarning(value);
};

export const calcTotalSalaryIncome = ({ mainJobIncome, sideJobIncome, formerJobsPaymentAmountSum }: TotalSalaryIncome): number => {
  return parseNumber(mainJobIncome) + parseNumber(sideJobIncome) + parseNumber(formerJobsPaymentAmountSum);
};
